"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectDrillableItems = void 0;
// (C) 2021 GoodData Corporation
var toolkit_1 = require("@reduxjs/toolkit");
var selectSelf = toolkit_1.createSelector(function (state) { return state; }, function (state) { return state.drill; });
/**
 * Returns drillable items that are currently set.
 *
 * @alpha
 */
exports.selectDrillableItems = toolkit_1.createSelector(selectSelf, function (state) {
    return state.drillableItems;
});
//# sourceMappingURL=drillSelectors.js.map